const RegistryCredentialType = Object.freeze({
  basic: 'BASIC',
  key: 'KEY',
  quay: 'QUAY',
});

export default RegistryCredentialType;
